import React, { useCallback, useState } from 'react'
import Accordion from 'components/accordion/Accordion'
import { Col, Row } from 'react-bootstrap'
import OrderHeader from './order_header/OrderHeader'
import { IOrder } from './IOrder'
import RedButton from 'components/inputs/RedButton'
import { reqStartPayment } from 'pay_work/PaymentRequests'
import { payWithSber } from 'pay_work/PayRequests'
import { reqCancelOrder } from './OrderRequests'
import OrderEndingLabel from './OrderEndingLabel'
import Notification from 'components/Notification'
import { formatPhoneNumber } from 'utils'
import WithGrayLabel from 'components/WithGrayLabel'
import CheckList from './CheckList'
import { HistoryOrderProductList } from 'product'
import OfficeInfoWithLoad from 'office/OfficeInfoWithLoad'
import { reqCalculateOrderPrice } from 'cart/CartRequests'
import BlueButton from 'components/inputs/BlueButton'
import EOrderStatus from './OrderStatus'

interface IOrderListItemForwardProps {
  onCancel?: (bidItem: IOrder) => void
}

interface IOrderListItemProps extends IOrderListItemForwardProps {
  order: IOrder
}

const OrderListItem: React.FC<IOrderListItemProps> = ({ order, onCancel }) => {
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [isLoading, setIsLoading] = useState(false)

  const handleCloseErrorNotification = useCallback(() => {
    setErrorMessage('')
  }, [])

  const handlePayClick = useCallback(() => {
    setIsLoading(true)
    reqCalculateOrderPrice(order.order_id, (orderPrice_) => {
      const price = orderPrice_.total_price
      // const price = 1
      reqStartPayment(order.order_id, (login?: string) => {
        if (!login) {
          setIsLoading(false)
          setErrorMessage('Произошла ошибка! Пожалуйста, повторите вход в систему')
        } else {
          payWithSber(login, order.order_id, price, (errorMessage: string) => {
            setIsLoading(false)
            setErrorMessage(errorMessage)
          })
        }
      })
    })
  }, [order])

  const handleCancelClick = useCallback(() => {
    setIsLoading(true)
    reqCancelOrder(order.order_id, () => {
      setIsLoading(false)
      if (onCancel) onCancel(order)
    })
  }, [order, onCancel])

  const renderHeader = useCallback(
    (isOpen: boolean, onToggleOpen: (event: any) => void) => {
      return <OrderHeader order={order} isOpen={isOpen} onToggleOpen={onToggleOpen} />
    },
    [order]
  )

  return (
    <Row className='border-t-full py-row'>
      <Notification
        show={!!errorMessage}
        title='Ошибка при оплате'
        icon='error'
        message={errorMessage}
        onClose={handleCloseErrorNotification}
      />

      <Accordion header='' renderHeader={renderHeader}>
        <div className='px-dynamic mt-2'>
          {order.is_pay_success === 1 ? (
            <div className='d-flex py-2 border-b-full'>
              <span
                style={{
                  fontSize: '1rem',
                  padding: '.6rem 1rem',
                }}
                className={'order-status-span success'}
              >
                Оплачено
              </span>
              <div className='m-1' />
              <RedButton disabled={isLoading} onClick={handleCancelClick}>
                Отменить
              </RedButton>
            </div>
          ) : order.status_id === EOrderStatus.IN_REVIEW ||
            order.status_id === EOrderStatus.READY ? (
            <div className='d-flex p-2 border-b-full'>
              <BlueButton disabled={isLoading} onClick={handlePayClick}>
                Оплатить
              </BlueButton>
              <div className='m-1' />
              <RedButton disabled={isLoading} onClick={handleCancelClick}>
                Отменить
              </RedButton>
            </div>
          ) : null}

          <HistoryOrderProductList products={order.products} />

          {order.deliv_price ? (
            <Row>
              <Col xs={9}>
                <div className='h3-rem'>Доставка:</div>
              </Col>
              <Col xs={3}>
                <h5>{order.deliv_price}&nbsp;₽</h5>
              </Col>
            </Row>
          ) : (
            <></>
          )}

          <WithGrayLabel label='Дополнительный номер телефона' nothingIfabsent>
            {formatPhoneNumber(order.extra_phone_number)}
          </WithGrayLabel>

          {order.receive_id === 2 ? (
            <WithGrayLabel label='Желаемое время доставки' nothingIfabsent>
              {`${order.desired_date} c ${order.desired_start_time} до ${order.desired_end_time}`}
            </WithGrayLabel>
          ) : (
            <>
              <Accordion header={order.receive_name}>
                <b>{order.office_name}</b>
                <OfficeInfoWithLoad officeId={order.office_id} />
              </Accordion>
            </>
          )}

          <WithGrayLabel label='Примечание' nothingIfabsent>
            {order.comments}
          </WithGrayLabel>

          <OrderEndingLabel order={order} />

          <div className='m-2' />
          {order.checks.length > 0 && <CheckList checks={order.checks} />}
        </div>
      </Accordion>
    </Row>
  )
}
export default OrderListItem
export type { IOrderListItemForwardProps }
